import '../modules/slider-mobile-swipe';
import '../modules/slider-banner';
import '../modules/slider-brands';
import svg4everybody from 'svg4everybody';
import objectFitImages from 'object-fit-images';
import UAParser from 'ua-parser-js';
import JQuery from 'jquery';

window.$ = window.JQuery = JQuery;

const parser = new UAParser().getResult();
const browser = parser.browser.name;
const version = parseInt(parser.browser.version).toFixed();

if ((browser == 'Edge' && version < 17) || (browser == 'Firefox' && version < 60)) {
  $('body').addClass('no-adaptiv-img');
}

// adds SVG External Content support to all browsers
svg4everybody();

// Polyfill object-fit/object-position on <img>
objectFitImages();

$('.js-cookies-close').on('click', function () {
  $(this).closest('.cookies').fadeOut();
});

$('.js-search').on('click', function () {
  $('.popup-search').slideToggle();
  $('.popup-search-input').focus();
});

$('.popup-search__close, main, footer').on('click', function (e) {
  if ($(e.target).hasClass('js-search'))
    return false;
  e.stopPropagation();
  $('.popup-search').slideUp();
});